import { gql } from "graphql-request";

export default gql`query ($maxNumItems: Int) {
	streamingQuery {
	  	getNewStreamingContent(maxNumItems: $maxNumItems) {
			__typename
			id
			title
			created
			originalTitle
			isSeries
			imagesPoster {
				__typename
				height
				width
				url
			}
			providerContents {
				id
				title
				url
				provider {
					id
					name
				}
			}
		}
	}
  }`;